import { Box, Typography } from '@mui/material'
import type { Indicador } from '../api/resumos'

/**
 * Os números do resumo contra o período anterior. A seta diz para onde o número foi; a cor e
 * a palavra ("melhor"/"pior") dizem se foi bom — investimento não tem juízo.
 */
export function IndicadoresResumo({ itens }: { itens: Indicador[] }) {
  if (!itens.length) return null
  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse', fontSize: 14, '& td, & th': { py: 0.75, px: 1, borderBottom: 1, borderColor: 'divider' } }}>
        <thead>
          <tr>
            {['', 'Indicador', 'Período', 'Anterior', 'Variação', 'Meta'].map((t, i) => (
              <Typography key={t || 'grupo'} component="th" variant="caption" color="text.secondary" sx={{ textAlign: i >= 2 ? 'right' : 'left', fontWeight: 600 }}>
                {t}
              </Typography>
            ))}
          </tr>
        </thead>
        <tbody>
          {itens.map((i) => {
            const seta = i.variacao?.startsWith('+') ? '▲ ' : i.variacao?.startsWith('-') ? '▼ ' : ''
            const cor = i.sentido === 'bom' ? 'success.main' : i.sentido === 'ruim' ? 'error.main' : 'text.secondary'
            return (
              <tr key={`${i.grupo}-${i.nome}`}>
                <Typography component="td" variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                  {i.grupo}
                </Typography>
                <Typography component="td" variant="body2">
                  {i.nome}
                </Typography>
                <Typography component="td" variant="body2" sx={{ textAlign: 'right', fontWeight: 600, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
                  {i.valor}
                </Typography>
                <Typography component="td" variant="body2" color="text.secondary" sx={{ textAlign: 'right', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
                  {i.anterior ?? '—'}
                </Typography>
                <Typography component="td" variant="body2" sx={{ textAlign: 'right', whiteSpace: 'nowrap', color: cor, fontVariantNumeric: 'tabular-nums' }}>
                  {i.variacao ? `${seta}${i.variacao}${i.sentido === 'bom' ? ' melhor' : i.sentido === 'ruim' ? ' pior' : ''}` : '—'}
                </Typography>
                <Typography component="td" variant="body2" color="text.secondary" sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                  {i.meta ?? ''}
                </Typography>
              </tr>
            )
          })}
        </tbody>
      </Box>
    </Box>
  )
}
